// assets/slider-component.js

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.slider');
    this.slides = this.querySelectorAll('.slider__slide');
    this.prevButton = this.querySelector('.slider-button--prev');
    this.nextButton = this.querySelector('.slider-button--next');
    this.currentIndex = 0;

    this.updateButtons();
    this.attachEvents();
  }

  attachEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.moveSlide(-1));
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.moveSlide(1));
    }
  }

  moveSlide(direction) {
    const slideWidth = this.slides[0].offsetWidth + 16; // 16px gap
    this.currentIndex += direction;
    this.slider.scrollBy({ left: slideWidth * direction, behavior: 'smooth' });
    this.updateButtons();
  }

  updateButtons() {
    const totalSlides = this.slides.length;
    if (this.currentIndex <= 0) this.currentIndex = 0;
    if (this.currentIndex >= totalSlides - 1) this.currentIndex = totalSlides - 1;
  }
}

customElements.define('slider-component', SliderComponent);
